import { createContext, type PropsWithChildren } from "react";
import type { Nullable } from "@/types";
import type Deltalight3dConfigurator from "../deltalight-3d-configurator.ts";
import useInitializedContext from "../hooks/use-initialized-context.ts";

type WebComponentHostContextType = Deltalight3dConfigurator;

const WebComponentHostContext = createContext<Nullable<WebComponentHostContextType>>(null);

export const useWebComponentHost = () => useInitializedContext(WebComponentHostContext, "WebComponentHost");

type Props = PropsWithChildren<{ host: Deltalight3dConfigurator }>;
export default function WebComponentHost({ children, host }: Props) {
    return <WebComponentHostContext value={host}>{children}</WebComponentHostContext>;
}
